import { cn } from '@/utils/styles';

import { IconProps } from '../types';

export function Topco({ className }: IconProps) {
  return (
    <svg
      className={cn(className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="figure"
      aria-labelledby="topco"
    >
      <g clip-path="url(#clip0_3302_1777)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.25 23.25H0.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.75 23.25V1.75C0.75 1.15 1.15 0.75 1.75 0.75H15.75C16.35 0.75 16.75 1.15 16.75 1.75V23.25"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.75 10.25H22.25C22.85 10.25 23.25 10.65 23.25 11.25V23.25"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 3.75H4V7.75H7V3.75Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 3.75H10.5V7.75H13.5V3.75Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 11.25H4V15.25H7V11.25Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 11.25H10.5V15.25H13.5V11.25Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.94995 23.2499V19.9499C6.94995 18.9499 7.74995 18.1499 8.74995 18.1499C9.74995 18.1499 10.55 18.9499 10.55 19.9499V23.2499"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3302_1777">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
